module.exports = __webpack_public_path__ + "static/Halima-e02b7da4f87e27f6e588c8124b4c5e63.png";